
// request.tsx
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export interface AddDCConnection {
	subId: string;
	datacenterIdSource: string;
	hardwareIdSource: number|null;
	portIdSource: number|null;
	capacityMbps: number;
	connectionType: string;
	datacenterIdDest?: string | number;
	datacenterSource?: string | null;
	hardwareIdDest?: number|null;
	portIdDest?: number|null;
  id?:number;
	metadata?: object;
}

//GET v1/dataCentersConnection
export function getAllConnections(token: string){
	return axios.get(`${API_URL}/v1/dataCentersConnection`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});	
}

//GET v1/dataCentersConnection/:id
export function getConnectionById(token: string, id: number){
	return axios.get(`${API_URL}/v1/dataCentersConnection/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});	
}

//POST v1/dataCentersConnection
export function addConnection(token: string, payload: AddDCConnection){
	return axios.post(`${API_URL}/v1/dataCentersConnection`,payload, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});	
}

//PUT v1/dataCentersConnection/:id
export function updateConnection(token: string, id: number, payload: AddDCConnection) {
	const encodedId = encodeURIComponent(id);
	return axios.put(`${API_URL}/v1/dataCentersConnection/${encodedId}`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//DELETE v1/dataCentersConnection/:id

export function deleteDCConnection(token: string, id: number) {
	const encodedId = encodeURIComponent(id);
	return axios.delete(`${API_URL}/v1/dataCentersConnection/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}